module.exports = __webpack_public_path__ + "static/media/icon_arrow_tab.6c2903d3.svg";